export const API_URL = '/api';
// export const API_URL = process.env.REACT_APP_POCKETBASE_URL;
// export const API_URL = 'https://pocketbase.ihub-1pmgames.by';
// export const API_URL = 'https://pocketbase-stage.chezaja.by';
